import { render, staticRenderFns } from "./VoucherShareLogs.vue?vue&type=template&id=ef181742&scoped=true"
import script from "./VoucherShareLogs.vue?vue&type=script&lang=js"
export * from "./VoucherShareLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef181742",
  null
  
)

export default component.exports